<div>
    <div class="container-xl m-0">
        <div class="row">
            <div class="col-lg-7 ml-0">
                <div class="text-center m-3">
                    <button (click)="saveMeme()" class="btn btn-outline-light font-weight-bold">Save Meme</button>
                </div>
                <!-- -----------Canvas------------ -->
                <canvas class="border-dark" id="canvas"></canvas>
            </div>
            <div class="col-md-5 text-dark resp">
                <div class="d-flex justify-content-center" *ngIf="formatFields == undefined">
                    <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"></div>
                    <strong>Loading Components</strong>   
                </div>
                <!-- ------------Form to update textboxex--------- -->
                <div *ngIf="formatFields != undefined">
                    <form #updateForm="ngForm" (change)="updateCanvas(updateForm)">
                        <div class="form-div">
                            <p class="lead text-white">Textbox tools</p>
                            <!-- Input for fill color -->
                            <label for="fill">
                                <svg class="bi bi-droplet-fill" width="1.5em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M8 16a6 6 0 0 0 6-6c0-1.655-1.122-2.904-2.432-4.362C10.254 4.176 8.75 2.503 8 0c0 0-6 5.686-6 10a6 6 0 0 0 6 6zM6.646 4.646c-.376.377-1.272 1.489-2.093 3.13l.894.448c.78-1.559 1.616-2.58 1.907-2.87l-.708-.708z"/>
                                </svg>
                            </label>
                            <input ngModel={{defaultFill}} type="color" name="tb_fill">
                            
                            <!-- Input for stroke color -->
                            <label class="ml-3" for="stroke">
                                <svg class="bi bi-brush" width="1.5em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.213 1.018a.572.572 0 0 1 .756.05.57.57 0 0 1 .057.746C15.085 3.082 12.044 7.107 9.6 9.55c-.71.71-1.42 1.243-1.952 1.596-.508.339-1.167.234-1.599-.197-.416-.416-.53-1.047-.212-1.543.346-.542.887-1.273 1.642-1.977 2.521-2.35 6.476-5.44 7.734-6.411z"/>
                                    <path d="M7 12a2 2 0 0 1-2 2c-1 0-2 0-3.5-.5s.5-1 1-1.5 1.395-2 2.5-2a2 2 0 0 1 2 2z"/>
                                </svg>
                            </label>
                            <input ngModel={{defaultStroke}} type="color" name="tb_stroke">
                            
                            <!-- Input for stroke width -->
                            <label class="ml-3" for="stroke">
                                <svg class="bi bi-slash" width="1.5em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/>
                                </svg>
                            </label>
                            <input ngModel={{defaultStrokeWidth}} type="range" name="tb_strokewidth" min="0" max="3" step="0.2" style="color:crimson"><br>
                            
                            <!-- Input for font style -->
                            <label class="mr-0" for="style">
                                <svg class="bi bi-fonts" width="1.5em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.258 3H3.747l-.082 2.46h.479c.26-1.544.758-1.783 2.693-1.845l.424-.013v7.827c0 .663-.144.82-1.3.923v.52h4.082v-.52c-1.162-.103-1.306-.26-1.306-.923V3.602l.43.013c1.935.062 2.434.301 2.694 1.846h.479L12.258 3z"/>
                                </svg>
                            </label>
                            <select ngModel={{defaultStyle}} name="style" class="text-justify">
                                <option value="Acme" style="font-family: 'Acme', sans-serif;">Acme</option>
                                <option value="Anton" style="font-family: 'Anton', sans-serif;">Anton</option>
                                <option value="Architects Daughter" style="font-family: 'Architects Daughter', cursive;">Architects Daughter</option>
                                <option value="Indie Flower" style="font-family: 'Indie Flower', cursive;">Indie Flower</option>
                                <option value="Lexend Tera" style="font-family: 'Lexend Tera', sans-serif;">Lexend Tera</option>
                                <option value="Lobster" style="font-family: 'Lobster', cursive;">Lobster</option>
                                <option value="Metal Mania" style="font-family: 'Metal Mania', cursive;">Metal Mania</option>
                                <option value="Oswald" style="font-family: 'Oswald', sans-serif;">Oswald</option>
                                <option value="Roboto Mono" style="font-family: 'Roboto Mono', monospace;">Roboto Mono</option>
                                <option value="Times New Roman">Times New Roman</option>
                            </select>

                            <!-- Button to remove textbox -->
                            <button class="btn btn-danger rounded-circle ml-5" title="Remove Textbox" (click)="removeTextbox()">
                                <svg class="bi bi-x" width="1.5em" height="1.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/>
                                    <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"/>
                                </svg>
                            </button>
                        </div>
                    </form>

                    <div class="w-100 mt-2">
                        <!-- Button to add textbox -->
                        <button class="btn btn-dark" (click)="addTextbox()">
                            <svg class="bi bi-plus" width="2em" height="2em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"/>
                                <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"/>
                            </svg>
                            Textbox
                        </button>
                        <!-- Button to add stickers -->
                        <!-- <button class="btn btn-dark" (click)="addSticker()">Add Sticker</button> -->
                    </div>
                </div>

                <!-- Instructions to use -->
                <h4 class="resp mt-3">Guidelines</h4>
                <ul>
                    <li>Drag to move textbox</li>
                    <li>Double click on textbox to edit text</li>
                    <li>Select a textbox to edit its properties</li>
                    <li>Resize textbox diagonally to change font size</li>
                    <li>You can resize the textboxes horizonatlly as well as vertically</li>
                    <li>You can rotate the textboxes</li>
                    <li>Save your meme directly to your device in high resolution</li>
                </ul>
            </div>
        </div>
    </div>
</div>